import { accountBlocFactory } from './chunk-PRXZQZGO.mjs';
export { accountBlocFactory, accountOutputSchema as accountSchema } from './chunk-PRXZQZGO.mjs';
import { app } from './chunk-ABZ5OBXE.mjs';
import { getAuth } from 'firebase/auth';

var auth = getAuth(app);

// src/account.ts
var accountBloc = accountBlocFactory({ auth });

export { accountBloc };
//# sourceMappingURL=account.mjs.map
//# sourceMappingURL=account.mjs.map